import HTTP from "../http";
import accountsHelper from "@/api/helpers/accounts";
import userStore from "@/store/modules/user";

async function verifyEmail(email) {
  try {
    let accountID = userStore.state.user.id;
    let body = accountsHelper.buildVerifyEmailBody(email);
    await HTTP.normal.post(`accounts/${accountID}/verify-email`, body);
  } catch (e) {
    try {
      if ((e.response.data.errors[0].title = "email desta conta já verificado"))
        return true;
    } catch (e) {}

    throw "Ocorreu um erro ao confirmar o email!";
  }
}

export default {
  verifyEmail
};



// WEBPACK FOOTER //
// ./src/api/modules/accounts.js